import { countryInfoRussia } from '../../../constants/constants';
export const convertCountrySSToFiasCountry = (country) => {
    if (!country || country.code === countryInfoRussia.code) {
        return countryInfoRussia;
    }
    return {
        fullName: country.name,
        code: country?.code || '',
        shortName: '',
    };
};
